import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-student-login',
  templateUrl: './student-login.component.html',
  styleUrls: ['./student-login.component.scss']
})
export class StudentLoginComponent implements OnInit {
  loginbtn = true;
  public showPassword: boolean;
  dialogRef: MatDialogRef<any>;
  user
  ShortName: string;
  userData: any;
  userType
  constructor(
    private fb: FormBuilder,
    public router: Router,
    public umsService: UmsService,
    private elRef: ElementRef, private modalPopupService: ModalpopService,
  ) { }
  loginForm: FormGroup;

  ngOnInit(): void {

    const the = localStorage.getItem('theme') ? localStorage.getItem('theme') : '';
    if (the.length <= 0) {
      this.theme('blue');
    } else {
      this.theme(the);
    }
    this.loginForm = this.fb.group({
      LoginName: ['', [Validators.required,Validators.pattern('[a-zA-z0-9]*$'), Validators.minLength(6)]],
      LoginPswd: ['', [Validators.required,Validators.pattern('[a-zA-z0-9]*$')]]
    });
    if (sessionStorage.getItem('ShortName') != null) {
      this.ShortName = sessionStorage.getItem('ShortName')
    }


  }

  theme(i) {
    if (i === 'white') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'gray');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'gray');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'gray');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'gray');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'black');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'black');
      localStorage.setItem('theme', i);
    } else if (i === 'yellow') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#d9c8a5');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#ffb10f');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#f0d6a1');
      localStorage.setItem('theme', i);
    } else if (i === 'red') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'red');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'red');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'red');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'red');
      localStorage.setItem('theme', i);
    } else if (i === 'green') {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'green');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'green');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'green');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'green');
      localStorage.setItem('theme', i);
    } else {
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#1254f4');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#7787bc');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#8f9cc0');
      localStorage.setItem('theme', i);
    }
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  Login() {
    // tslint:disable-next-line:prefer-const
    let payload = this.loginForm.value;
    if (payload.LoginName == '' && payload.LoginPswd == '') {
      this.loginForm.get('LoginName').markAsTouched();
      this.loginForm.get('LoginPswd').markAsTouched();
      return;
    }
    else if (payload.LoginName != '' && payload.LoginPswd == '') {
      this.loginForm.get('LoginPswd').markAsTouched();
      return;
    }
    else {
      this.onLogin();
    }
  }

  onLogin() {
    // tslint:disable-next-line:prefer-const
    let payload = this.loginForm.value;
    sessionStorage.setItem('TLoginName', this.loginForm.value.LoginName)
    this.umsService.login(payload).subscribe(async res => {
      if (res.status === true) {
        sessionStorage.clear();
        localStorage.clear();
        
        localStorage.setItem('user', 'student');
        sessionStorage.setItem('userId', res.data[0].id);
        localStorage.setItem('headerlist', JSON.stringify(res));
        
        sessionStorage.setItem('token', res.token);
        sessionStorage.setItem('Inst', '6');
        // this.redirect('home');
        this.umsService.secret(res.projectPharam);
       
        await this.umsService.getUserData(res.data[0].id).subscribe(async res => {
          this.userData = res.data[0][0];
          sessionStorage.setItem('userType', res.data[0][0].LoginLevel)
          if (res.data[0][0].LoginLevel == 11) {
            this.userType = 'Super Admin'
          }
          else if (res.data[0][0].LoginLevel == 10) {
            this.userType = 'Admin'
          }
          else if (res.data[0][0].LoginLevel == 6) {
            this.userType = 'User'
          }else if (res.data[0][0].LoginLevel == 1) {
            this.userType = 'Teacher'
          }
          else {
            this.userType = 'Student'
          }

          let payload = {};
          payload['UserId'] = res.data[0][0].LoginId;
          await this.umsService.getPermission(payload).subscribe(resPermission => {
            
            let permissionData = resPermission.data;
            sessionStorage.setItem("userPermission", JSON.stringify(resPermission.data));
           
            if (this.userType != 'Super Admin' && this.userType !== 'Admin') {
              
              if (resPermission.data.length != 0) {
                
                permissionData.forEach(element => {
                  if (element.PView == true && element.PageName == 'Dashboard') {
                    var link = document.createElement('a');
                    link.setAttribute("href", "/home");
                    link.click()

                  }
                  else {
                    var link = document.createElement('a');
                    link.setAttribute("href", "/HomePage");
                    link.click()
                  }

                });
              }
              else {
                var link = document.createElement('a');
                link.setAttribute("href", "/HomePage");
                link.click()
              } 
            }
            else {
              var link = document.createElement('a');
              link.setAttribute("href", "/home");
              link.click()
            }

          })
        });




        ;
      }
      else {
        // const  data = {};
        // data['message'] = res.message;
        // data['title'] = 'Alert';
        // data['icon'] = 'fas fa-close';
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        alert(res.message);
        this.umsService.openSnackbar(res.message);
      }

    });
  }



  getUserData() {
    let id = sessionStorage.getItem('userId');
    this.umsService.getUserData(id).subscribe((res) => {
      this.userData = res.data[0][0];
      sessionStorage.setItem('userType', res.data[0][0].LoginLevel)
      sessionStorage.setItem('TLoginName', res.data[0][0].LoginName)
      // this.usertyp();
    });
  }

  ForgotPass() {
    this.redirect('forgot-password');
  }

  SignUp() {
    this.redirect('sign-up');
  }

}